import { Book } from "../types";
import "./addBook.css";
export const BookRow = ({ book, onClick }: { book: Book; onClick: any }) => {
  return (
    <div onClick={onClick} className="bookRow">
      <img
        className="imageBookRow"
        alt={book.title}
        src={book.imageLink?.smallThumbnail}
      />
      <div className="bookRowTextContainer">
        <p className="title">{book.title}</p>
        <p className="author">{book.author}</p>
      </div>
    </div>
  );
};
